import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@beweegbaas/ui";
import { createFileRoute } from "@tanstack/react-router";
import { PasskeyForm } from "#/components/form.passkey";
import { TwoFactorAuthForm } from "#/modules/user.account-settings/components/form.two-factor-auth";
import { UpdatePasswordForm } from "#/modules/user.account-settings/components/form.update-password";
import { getAccountUserInfo } from "#/modules/user.account-settings/user.functions";
import { m } from "#/paraglide/messages";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/account-settings/security",
)({
  // Load fresh user info so the 2FA state reflects post-mutation values (survives invalidation).
  loader: () => getAccountUserInfo(),
  component: SecurityPage,
});

// Portal's `page.security` inlined into the route component.
function SecurityPage() {
  const userInfo = Route.useLoaderData();
  const twoFactorEnabled = userInfo.twoFactorEnabled ?? false;

  return (
    <div className="flex flex-col gap-6">
      <Card>
        <CardHeader>
          <CardTitle>{m["common.fields.password"]()}</CardTitle>
          <CardDescription>{m["account.password_description"]()}</CardDescription>
        </CardHeader>
        <CardContent>
          <UpdatePasswordForm />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>{m["account.two_factor_auth"]()}</CardTitle>
          <CardDescription>{m["account.two_factor_auth_description"]()}</CardDescription>
        </CardHeader>
        <TwoFactorAuthForm twoFactorEnabled={twoFactorEnabled} />
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>
            {m["auth.passkey.title"]()}
            <span className="text-muted-foreground ml-1 text-sm">
              {m["account.passkey_fast_login_hint"]()}
            </span>
          </CardTitle>
          <CardDescription>
            {twoFactorEnabled
              ? m["auth.passkey.description"]()
              : m["auth.passkey.2fa_required_description"]()}
          </CardDescription>
        </CardHeader>

        {/* Passkeys require 2FA. PasskeyForm self-manages its list via listPasskeysFn + react-query. */}
        {twoFactorEnabled ? <PasskeyForm /> : null}
      </Card>
    </div>
  );
}
